import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/blog/',
    component: ComponentCreator('/blog/', '3f5'),
    exact: true
  },
  {
    path: '/blog/analise/codigo-desobfuscado/',
    component: ComponentCreator('/blog/analise/codigo-desobfuscado/', '1c5'),
    exact: true
  },
  {
    path: '/blog/analise/fim-dos-chunks-de-spawn/',
    component: ComponentCreator('/blog/analise/fim-dos-chunks-de-spawn/', '6e1'),
    exact: true
  },
  {
    path: '/blog/anuncio/a-era-do-cobre/',
    component: ComponentCreator('/blog/anuncio/a-era-do-cobre/', '1d6'),
    exact: true
  },
  {
    path: '/blog/anuncio/block-friday-2025/',
    component: ComponentCreator('/blog/anuncio/block-friday-2025/', 'bd3'),
    exact: true
  },
  {
    path: '/blog/anuncio/data-montaria-caotica/',
    component: ComponentCreator('/blog/anuncio/data-montaria-caotica/', '848'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-1-21-11/',
    component: ComponentCreator('/blog/anuncio/minecraft-1-21-11/', '31b'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-pre-release-1/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-pre-release-1/', '51d'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-pre-release-2/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-pre-release-2/', 'ae2'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-pre-release-3/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-pre-release-3/', 'fe2'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-release-candidate-2/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-release-candidate-2/', '3a9'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-release-candidate-3/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-release-candidate-3/', 'd83'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-1/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-1/', 'cb9'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-10/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-10/', '800'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-11/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-11/', '0d6'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-2/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-2/', 'cda'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-3/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-3/', 'b7f'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-4/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-4/', '8b2'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-5/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-5/', 'a8a'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-6/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-6/', 'f00'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-7/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-7/', '914'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-8/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-8/', 'e6b'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1-snapshot-9/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1-snapshot-9/', '5cb'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-1/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-1/', 'b1d'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-2/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-2/', '7ba'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-3/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-3/', '3b9'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-4-snapshot-1/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-4-snapshot-1/', 'a89'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-4-snapshot-2/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-4-snapshot-2/', '7b3'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-4-snapshot-3/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-4-snapshot-3/', '5cd'),
    exact: true
  },
  {
    path: '/blog/anuncio/minecraft-26-4-snapshot-4/',
    component: ComponentCreator('/blog/anuncio/minecraft-26-4-snapshot-4/', 'c86'),
    exact: true
  },
  {
    path: '/blog/anuncio/numeracao-de-versoes/',
    component: ComponentCreator('/blog/anuncio/numeracao-de-versoes/', '730'),
    exact: true
  },
  {
    path: '/blog/archive/',
    component: ComponentCreator('/blog/archive/', '1d9'),
    exact: true
  },
  {
    path: '/blog/authors/',
    component: ComponentCreator('/blog/authors/', '347'),
    exact: true
  },
  {
    path: '/blog/futuro-armageddon-2027-metagame/',
    component: ComponentCreator('/blog/futuro-armageddon-2027-metagame/', 'ccf'),
    exact: true
  },
  {
    path: '/blog/guia/bases-secretas-semi-anarquia/',
    component: ComponentCreator('/blog/guia/bases-secretas-semi-anarquia/', 'dd2'),
    exact: true
  },
  {
    path: '/blog/guia/como-comecar-semi-anarquia/',
    component: ComponentCreator('/blog/guia/como-comecar-semi-anarquia/', '65c'),
    exact: true
  },
  {
    path: '/blog/guia/como-ganhar-dinheiro/',
    component: ComponentCreator('/blog/guia/como-ganhar-dinheiro/', '1f6'),
    exact: true
  },
  {
    path: '/blog/guia/como-jogar-armageddon/',
    component: ComponentCreator('/blog/guia/como-jogar-armageddon/', '490'),
    exact: true
  },
  {
    path: '/blog/guia/economia-semi-anarquia/',
    component: ComponentCreator('/blog/guia/economia-semi-anarquia/', '9f6'),
    exact: true
  },
  {
    path: '/blog/guia/eventos-torneios-armageddon/',
    component: ComponentCreator('/blog/guia/eventos-torneios-armageddon/', '752'),
    exact: true
  },
  {
    path: '/blog/guia/guia-clas-armageddon/',
    component: ComponentCreator('/blog/guia/guia-clas-armageddon/', '36d'),
    exact: true
  },
  {
    path: '/blog/guia/instalar-fabric/',
    component: ComponentCreator('/blog/guia/instalar-fabric/', '4d2'),
    exact: true
  },
  {
    path: '/blog/guia/mapart/',
    component: ComponentCreator('/blog/guia/mapart/', '14f'),
    exact: true
  },
  {
    path: '/blog/guia/modo-smp/',
    component: ComponentCreator('/blog/guia/modo-smp/', 'afa'),
    exact: true
  },
  {
    path: '/blog/guia/presentear/',
    component: ComponentCreator('/blog/guia/presentear/', '679'),
    exact: true
  },
  {
    path: '/blog/guia/proteger-casa-armageddon/',
    component: ComponentCreator('/blog/guia/proteger-casa-armageddon/', '5be'),
    exact: true
  },
  {
    path: '/blog/guia/pvp-duelos-semi-anarquia/',
    component: ComponentCreator('/blog/guia/pvp-duelos-semi-anarquia/', '157'),
    exact: true
  },
  {
    path: '/blog/guia/sklauncher/',
    component: ComponentCreator('/blog/guia/sklauncher/', '99d'),
    exact: true
  },
  {
    path: '/blog/guia/times-aliancas-semi-anarquia/',
    component: ComponentCreator('/blog/guia/times-aliancas-semi-anarquia/', '694'),
    exact: true
  },
  {
    path: '/blog/mercado-dinamico/',
    component: ComponentCreator('/blog/mercado-dinamico/', '686'),
    exact: true
  },
  {
    path: '/blog/monstros-halloween/',
    component: ComponentCreator('/blog/monstros-halloween/', '2c1'),
    exact: true
  },
  {
    path: '/blog/nethernet-bedrock/',
    component: ComponentCreator('/blog/nethernet-bedrock/', '1f1'),
    exact: true
  },
  {
    path: '/blog/page/10/',
    component: ComponentCreator('/blog/page/10/', '7ce'),
    exact: true
  },
  {
    path: '/blog/page/11/',
    component: ComponentCreator('/blog/page/11/', 'e4a'),
    exact: true
  },
  {
    path: '/blog/page/2/',
    component: ComponentCreator('/blog/page/2/', '8b9'),
    exact: true
  },
  {
    path: '/blog/page/3/',
    component: ComponentCreator('/blog/page/3/', '2dc'),
    exact: true
  },
  {
    path: '/blog/page/4/',
    component: ComponentCreator('/blog/page/4/', '084'),
    exact: true
  },
  {
    path: '/blog/page/5/',
    component: ComponentCreator('/blog/page/5/', '6e3'),
    exact: true
  },
  {
    path: '/blog/page/6/',
    component: ComponentCreator('/blog/page/6/', 'bef'),
    exact: true
  },
  {
    path: '/blog/page/7/',
    component: ComponentCreator('/blog/page/7/', 'c64'),
    exact: true
  },
  {
    path: '/blog/page/8/',
    component: ComponentCreator('/blog/page/8/', '723'),
    exact: true
  },
  {
    path: '/blog/page/9/',
    component: ComponentCreator('/blog/page/9/', '512'),
    exact: true
  },
  {
    path: '/blog/protecoes-inatividade-dezembro-2026/',
    component: ComponentCreator('/blog/protecoes-inatividade-dezembro-2026/', 'f5a'),
    exact: true
  },
  {
    path: '/blog/spoiler-metagame-conquistas-marcos/',
    component: ComponentCreator('/blog/spoiler-metagame-conquistas-marcos/', '40e'),
    exact: true
  },
  {
    path: '/blog/spoiler-metagame-nivel-conta-prestigio/',
    component: ComponentCreator('/blog/spoiler-metagame-nivel-conta-prestigio/', '4bf'),
    exact: true
  },
  {
    path: '/blog/spoiler-metagame-prestigio-proxima-ascensao/',
    component: ComponentCreator('/blog/spoiler-metagame-prestigio-proxima-ascensao/', 'bab'),
    exact: true
  },
  {
    path: '/blog/tags/',
    component: ComponentCreator('/blog/tags/', 'e17'),
    exact: true
  },
  {
    path: '/blog/tags/adicionado/',
    component: ComponentCreator('/blog/tags/adicionado/', '257'),
    exact: true
  },
  {
    path: '/blog/tags/adicionado/page/2/',
    component: ComponentCreator('/blog/tags/adicionado/page/2/', '369'),
    exact: true
  },
  {
    path: '/blog/tags/adicionado/page/3/',
    component: ComponentCreator('/blog/tags/adicionado/page/3/', 'a6f'),
    exact: true
  },
  {
    path: '/blog/tags/adicionado/page/4/',
    component: ComponentCreator('/blog/tags/adicionado/page/4/', 'b67'),
    exact: true
  },
  {
    path: '/blog/tags/adicionado/page/5/',
    component: ComponentCreator('/blog/tags/adicionado/page/5/', '17d'),
    exact: true
  },
  {
    path: '/blog/tags/alterado/',
    component: ComponentCreator('/blog/tags/alterado/', '5de'),
    exact: true
  },
  {
    path: '/blog/tags/alterado/page/2/',
    component: ComponentCreator('/blog/tags/alterado/page/2/', '771'),
    exact: true
  },
  {
    path: '/blog/tags/alterado/page/3/',
    component: ComponentCreator('/blog/tags/alterado/page/3/', 'd7c'),
    exact: true
  },
  {
    path: '/blog/tags/alterado/page/4/',
    component: ComponentCreator('/blog/tags/alterado/page/4/', '502'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-minecraft/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-minecraft/', '499'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-minecraft/page/2/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-minecraft/page/2/', '9e2'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-minecraft/page/3/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-minecraft/page/3/', 'eca'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/', '22a'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/page/2/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/page/2/', 'e55'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/page/3/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/page/3/', '0ea'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/page/4/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/page/4/', '842'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/page/5/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/page/5/', '999'),
    exact: true
  },
  {
    path: '/blog/tags/atualizacoes-do-servidor/page/6/',
    component: ComponentCreator('/blog/tags/atualizacoes-do-servidor/page/6/', '61c'),
    exact: true
  },
  {
    path: '/blog/tags/candidate/',
    component: ComponentCreator('/blog/tags/candidate/', 'b12'),
    exact: true
  },
  {
    path: '/blog/tags/eden/',
    component: ComponentCreator('/blog/tags/eden/', '547'),
    exact: true
  },
  {
    path: '/blog/tags/pre-release/',
    component: ComponentCreator('/blog/tags/pre-release/', 'f0b'),
    exact: true
  },
  {
    path: '/blog/tags/release/',
    component: ComponentCreator('/blog/tags/release/', 'f29'),
    exact: true
  },
  {
    path: '/blog/tags/removido/',
    component: ComponentCreator('/blog/tags/removido/', 'ef2'),
    exact: true
  },
  {
    path: '/blog/tags/removido/page/2/',
    component: ComponentCreator('/blog/tags/removido/page/2/', '2c0'),
    exact: true
  },
  {
    path: '/blog/tags/removido/page/3/',
    component: ComponentCreator('/blog/tags/removido/page/3/', '4cd'),
    exact: true
  },
  {
    path: '/blog/tags/resolvido/',
    component: ComponentCreator('/blog/tags/resolvido/', '1d8'),
    exact: true
  },
  {
    path: '/blog/tags/resolvido/page/2/',
    component: ComponentCreator('/blog/tags/resolvido/page/2/', '9c3'),
    exact: true
  },
  {
    path: '/blog/tags/resolvido/page/3/',
    component: ComponentCreator('/blog/tags/resolvido/page/3/', 'edf'),
    exact: true
  },
  {
    path: '/blog/tags/resolvido/page/4/',
    component: ComponentCreator('/blog/tags/resolvido/page/4/', 'f22'),
    exact: true
  },
  {
    path: '/blog/tags/resolvido/page/5/',
    component: ComponentCreator('/blog/tags/resolvido/page/5/', 'dd8'),
    exact: true
  },
  {
    path: '/blog/tags/semi-anarquia/',
    component: ComponentCreator('/blog/tags/semi-anarquia/', 'eaf'),
    exact: true
  },
  {
    path: '/blog/tags/snapshot/',
    component: ComponentCreator('/blog/tags/snapshot/', 'bc0'),
    exact: true
  },
  {
    path: '/blog/tags/snapshot/page/2/',
    component: ComponentCreator('/blog/tags/snapshot/page/2/', '8eb'),
    exact: true
  },
  {
    path: '/blog/torneio-influencers/',
    component: ComponentCreator('/blog/torneio-influencers/', 'a76'),
    exact: true
  },
  {
    path: '/blog/update/1.0.0/',
    component: ComponentCreator('/blog/update/1.0.0/', '331'),
    exact: true
  },
  {
    path: '/blog/update/1.0.1/',
    component: ComponentCreator('/blog/update/1.0.1/', 'eb4'),
    exact: true
  },
  {
    path: '/blog/update/1.0.2/',
    component: ComponentCreator('/blog/update/1.0.2/', '524'),
    exact: true
  },
  {
    path: '/blog/update/1.0.3/',
    component: ComponentCreator('/blog/update/1.0.3/', 'f0b'),
    exact: true
  },
  {
    path: '/blog/update/1.0.4/',
    component: ComponentCreator('/blog/update/1.0.4/', '3ed'),
    exact: true
  },
  {
    path: '/blog/update/1.0.5/',
    component: ComponentCreator('/blog/update/1.0.5/', '826'),
    exact: true
  },
  {
    path: '/blog/update/1.0.6/',
    component: ComponentCreator('/blog/update/1.0.6/', '10f'),
    exact: true
  },
  {
    path: '/blog/update/1.0.7/',
    component: ComponentCreator('/blog/update/1.0.7/', '039'),
    exact: true
  },
  {
    path: '/blog/update/1.0.8/',
    component: ComponentCreator('/blog/update/1.0.8/', '341'),
    exact: true
  },
  {
    path: '/blog/update/1.0.9/',
    component: ComponentCreator('/blog/update/1.0.9/', '07c'),
    exact: true
  },
  {
    path: '/blog/update/1.1.0/',
    component: ComponentCreator('/blog/update/1.1.0/', '3ff'),
    exact: true
  },
  {
    path: '/blog/update/1.1.1/',
    component: ComponentCreator('/blog/update/1.1.1/', 'e3d'),
    exact: true
  },
  {
    path: '/blog/update/1.1.2/',
    component: ComponentCreator('/blog/update/1.1.2/', 'efb'),
    exact: true
  },
  {
    path: '/blog/update/1.1.3/',
    component: ComponentCreator('/blog/update/1.1.3/', '0c1'),
    exact: true
  },
  {
    path: '/blog/update/1.1.4/',
    component: ComponentCreator('/blog/update/1.1.4/', '256'),
    exact: true
  },
  {
    path: '/blog/update/1.1.5/',
    component: ComponentCreator('/blog/update/1.1.5/', '5d4'),
    exact: true
  },
  {
    path: '/blog/update/1.1.6/',
    component: ComponentCreator('/blog/update/1.1.6/', '38a'),
    exact: true
  },
  {
    path: '/blog/update/1.1.7/',
    component: ComponentCreator('/blog/update/1.1.7/', 'e68'),
    exact: true
  },
  {
    path: '/blog/update/1.1.8/',
    component: ComponentCreator('/blog/update/1.1.8/', '827'),
    exact: true
  },
  {
    path: '/blog/update/1.2.0/',
    component: ComponentCreator('/blog/update/1.2.0/', '8ce'),
    exact: true
  },
  {
    path: '/blog/update/1.2.1/',
    component: ComponentCreator('/blog/update/1.2.1/', '217'),
    exact: true
  },
  {
    path: '/blog/update/1.2.10/',
    component: ComponentCreator('/blog/update/1.2.10/', '09d'),
    exact: true
  },
  {
    path: '/blog/update/1.2.11/',
    component: ComponentCreator('/blog/update/1.2.11/', 'a1e'),
    exact: true
  },
  {
    path: '/blog/update/1.2.12/',
    component: ComponentCreator('/blog/update/1.2.12/', 'cdb'),
    exact: true
  },
  {
    path: '/blog/update/1.2.13/',
    component: ComponentCreator('/blog/update/1.2.13/', '856'),
    exact: true
  },
  {
    path: '/blog/update/1.2.14/',
    component: ComponentCreator('/blog/update/1.2.14/', '3ff'),
    exact: true
  },
  {
    path: '/blog/update/1.2.15/',
    component: ComponentCreator('/blog/update/1.2.15/', 'ec1'),
    exact: true
  },
  {
    path: '/blog/update/1.2.16/',
    component: ComponentCreator('/blog/update/1.2.16/', '6f8'),
    exact: true
  },
  {
    path: '/blog/update/1.2.2/',
    component: ComponentCreator('/blog/update/1.2.2/', 'e5e'),
    exact: true
  },
  {
    path: '/blog/update/1.2.3/',
    component: ComponentCreator('/blog/update/1.2.3/', 'f4c'),
    exact: true
  },
  {
    path: '/blog/update/1.2.4/',
    component: ComponentCreator('/blog/update/1.2.4/', 'b91'),
    exact: true
  },
  {
    path: '/blog/update/1.2.5/',
    component: ComponentCreator('/blog/update/1.2.5/', '359'),
    exact: true
  },
  {
    path: '/blog/update/1.2.6/',
    component: ComponentCreator('/blog/update/1.2.6/', 'b0a'),
    exact: true
  },
  {
    path: '/blog/update/1.2.7/',
    component: ComponentCreator('/blog/update/1.2.7/', '909'),
    exact: true
  },
  {
    path: '/blog/update/1.2.8/',
    component: ComponentCreator('/blog/update/1.2.8/', '751'),
    exact: true
  },
  {
    path: '/blog/update/1.2.9/',
    component: ComponentCreator('/blog/update/1.2.9/', 'ccf'),
    exact: true
  },
  {
    path: '/blog/update/1.3.0/',
    component: ComponentCreator('/blog/update/1.3.0/', 'd71'),
    exact: true
  },
  {
    path: '/blog/update/1.3.1/',
    component: ComponentCreator('/blog/update/1.3.1/', 'dbe'),
    exact: true
  },
  {
    path: '/blog/update/1.3.2/',
    component: ComponentCreator('/blog/update/1.3.2/', '113'),
    exact: true
  },
  {
    path: '/blog/update/1.3.3/',
    component: ComponentCreator('/blog/update/1.3.3/', '114'),
    exact: true
  },
  {
    path: '/blog/update/1.3.4/',
    component: ComponentCreator('/blog/update/1.3.4/', '0a7'),
    exact: true
  },
  {
    path: '/blog/update/1.3.5/',
    component: ComponentCreator('/blog/update/1.3.5/', 'c37'),
    exact: true
  },
  {
    path: '/blog/update/1.3.6/',
    component: ComponentCreator('/blog/update/1.3.6/', '1a9'),
    exact: true
  },
  {
    path: '/blog/update/1.3.7/',
    component: ComponentCreator('/blog/update/1.3.7/', 'a70'),
    exact: true
  },
  {
    path: '/blog/update/1.3.8/',
    component: ComponentCreator('/blog/update/1.3.8/', 'e2a'),
    exact: true
  },
  {
    path: '/blog/update/1.3.9/',
    component: ComponentCreator('/blog/update/1.3.9/', 'b51'),
    exact: true
  },
  {
    path: '/blog/update/1.4.0/',
    component: ComponentCreator('/blog/update/1.4.0/', '6d9'),
    exact: true
  },
  {
    path: '/blog/update/1.4.1/',
    component: ComponentCreator('/blog/update/1.4.1/', 'a92'),
    exact: true
  },
  {
    path: '/blog/update/1.4.2/',
    component: ComponentCreator('/blog/update/1.4.2/', 'bd6'),
    exact: true
  },
  {
    path: '/blog/update/1.4.3/',
    component: ComponentCreator('/blog/update/1.4.3/', '70f'),
    exact: true
  },
  {
    path: '/blog/update/1.4.4/',
    component: ComponentCreator('/blog/update/1.4.4/', '490'),
    exact: true
  },
  {
    path: '/blog/update/1.4.5/',
    component: ComponentCreator('/blog/update/1.4.5/', 'db5'),
    exact: true
  },
  {
    path: '/blog/update/1.4.6/',
    component: ComponentCreator('/blog/update/1.4.6/', '3fa'),
    exact: true
  },
  {
    path: '/discord/',
    component: ComponentCreator('/discord/', 'e58'),
    exact: true
  },
  {
    path: '/equipe/',
    component: ComponentCreator('/equipe/', '1fa'),
    exact: true
  },
  {
    path: '/form/',
    component: ComponentCreator('/form/', '70e'),
    exact: true
  },
  {
    path: '/gradiente/',
    component: ComponentCreator('/gradiente/', '8e9'),
    exact: true
  },
  {
    path: '/ideias-de-videos/',
    component: ComponentCreator('/ideias-de-videos/', '6c8'),
    exact: true
  },
  {
    path: '/jogar/',
    component: ComponentCreator('/jogar/', '48c'),
    exact: true
  },
  {
    path: '/jogar/bedrock/',
    component: ComponentCreator('/jogar/bedrock/', 'd03'),
    exact: true
  },
  {
    path: '/jogar/java/',
    component: ComponentCreator('/jogar/java/', 'b26'),
    exact: true
  },
  {
    path: '/jogar/vincular-contas/',
    component: ComponentCreator('/jogar/vincular-contas/', '04d'),
    exact: true
  },
  {
    path: '/legal/politica-de-privacidade/',
    component: ComponentCreator('/legal/politica-de-privacidade/', '3f9'),
    exact: true
  },
  {
    path: '/legal/termo-de-servico/',
    component: ComponentCreator('/legal/termo-de-servico/', 'b18'),
    exact: true
  },
  {
    path: '/meuip/',
    component: ComponentCreator('/meuip/', 'd02'),
    exact: true
  },
  {
    path: '/regras/',
    component: ComponentCreator('/regras/', 'dcb'),
    exact: true
  },
  {
    path: '/search/',
    component: ComponentCreator('/search/', '7cb'),
    exact: true
  },
  {
    path: '/servidor-minecraft-brasileiro/',
    component: ComponentCreator('/servidor-minecraft-brasileiro/', 'd02'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-clans/',
    component: ComponentCreator('/servidor-minecraft-com-clans/', '64a'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-dungeons/',
    component: ComponentCreator('/servidor-minecraft-com-dungeons/', '5cc'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-economia/',
    component: ComponentCreator('/servidor-minecraft-com-economia/', '751'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-eventos/',
    component: ComponentCreator('/servidor-minecraft-com-eventos/', 'a06'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-fabricas/',
    component: ComponentCreator('/servidor-minecraft-com-fabricas/', '1ad'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-java-bedrock/',
    component: ComponentCreator('/servidor-minecraft-com-java-bedrock/', '9df'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-leilao/',
    component: ComponentCreator('/servidor-minecraft-com-leilao/', 'b82'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-loja-de-jogadores/',
    component: ComponentCreator('/servidor-minecraft-com-loja-de-jogadores/', '041'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-mcmmo/',
    component: ComponentCreator('/servidor-minecraft-com-mcmmo/', '286'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-protecao-de-terreno/',
    component: ComponentCreator('/servidor-minecraft-com-protecao-de-terreno/', 'ce1'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-torneios/',
    component: ComponentCreator('/servidor-minecraft-com-torneios/', '2b9'),
    exact: true
  },
  {
    path: '/servidor-minecraft-com-voice-chat/',
    component: ComponentCreator('/servidor-minecraft-com-voice-chat/', 'cfc'),
    exact: true
  },
  {
    path: '/servidor-minecraft-semi-anarquia/',
    component: ComponentCreator('/servidor-minecraft-semi-anarquia/', 'b11'),
    exact: true
  },
  {
    path: '/servidor-minecraft-skyblock/',
    component: ComponentCreator('/servidor-minecraft-skyblock/', '4f4'),
    exact: true
  },
  {
    path: '/servidor-minecraft-survival/',
    component: ComponentCreator('/servidor-minecraft-survival/', 'b1f'),
    exact: true
  },
  {
    path: '/servidor-minecraft/',
    component: ComponentCreator('/servidor-minecraft/', '6ab'),
    exact: true
  },
  {
    path: '/textura/',
    component: ComponentCreator('/textura/', 'b74'),
    exact: true
  },
  {
    path: '/vote/',
    component: ComponentCreator('/vote/', '7e4'),
    exact: true
  },
  {
    path: '/vote/README/',
    component: ComponentCreator('/vote/README/', '9d8'),
    exact: true
  },
  {
    path: '/wiki/',
    component: ComponentCreator('/wiki/', 'ae9'),
    routes: [
      {
        path: '/wiki/',
        component: ComponentCreator('/wiki/', '46c'),
        routes: [
          {
            path: '/wiki/',
            component: ComponentCreator('/wiki/', '15d'),
            routes: [
              {
                path: '/wiki/',
                component: ComponentCreator('/wiki/', '390'),
                exact: true
              },
              {
                path: '/wiki/geral/',
                component: ComponentCreator('/wiki/geral/', 'a25'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/conta/',
                component: ComponentCreator('/wiki/geral/conta/', '1d6'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/conta/exclusao/',
                component: ComponentCreator('/wiki/geral/conta/exclusao/', '552'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/conta/proteger/',
                component: ComponentCreator('/wiki/geral/conta/proteger/', '060'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/conta/registro/',
                component: ComponentCreator('/wiki/geral/conta/registro/', '566'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/conta/transferencia/',
                component: ComponentCreator('/wiki/geral/conta/transferencia/', '5bd'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/discord/',
                component: ComponentCreator('/wiki/geral/discord/', '5ee'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/discord/booster/',
                component: ComponentCreator('/wiki/geral/discord/booster/', 'a74'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/discord/cargos/',
                component: ComponentCreator('/wiki/geral/discord/cargos/', 'e17'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/discord/comandos/',
                component: ComponentCreator('/wiki/geral/discord/comandos/', 'aa1'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/discord/vincular/',
                component: ComponentCreator('/wiki/geral/discord/vincular/', '2ff'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/influencer/',
                component: ComponentCreator('/wiki/geral/influencer/', 'ce4'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/',
                component: ComponentCreator('/wiki/geral/mods/', 'c97'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/chat-voz/',
                component: ComponentCreator('/wiki/geral/mods/chat-voz/', '0d7'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/chat-voz/plasmo-voice/',
                component: ComponentCreator('/wiki/geral/mods/chat-voz/plasmo-voice/', 'e0e'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/chat-voz/simple-voice-chat/',
                component: ComponentCreator('/wiki/geral/mods/chat-voz/simple-voice-chat/', '8c5'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/minimapas/',
                component: ComponentCreator('/wiki/geral/mods/minimapas/', '0a7'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/minimapas/journeymap/',
                component: ComponentCreator('/wiki/geral/mods/minimapas/journeymap/', '102'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/minimapas/voxelmap/',
                component: ComponentCreator('/wiki/geral/mods/minimapas/voxelmap/', 'd8e'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/minimapas/xaeros-minimap/',
                component: ComponentCreator('/wiki/geral/mods/minimapas/xaeros-minimap/', '46e'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/minimapas/xaeros-world-map/',
                component: ComponentCreator('/wiki/geral/mods/minimapas/xaeros-world-map/', '77f'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/visao-distante/',
                component: ComponentCreator('/wiki/geral/mods/visao-distante/', '1e8'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/visao-distante/distant-horizons/',
                component: ComponentCreator('/wiki/geral/mods/visao-distante/distant-horizons/', '54b'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/mods/visao-distante/voxy/',
                component: ComponentCreator('/wiki/geral/mods/visao-distante/voxy/', '27d'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/personalizacao/',
                component: ComponentCreator('/wiki/geral/personalizacao/', '21d'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/personalizacao/recursos/',
                component: ComponentCreator('/wiki/geral/personalizacao/recursos/', 'f2a'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/personalizacao/skins/',
                component: ComponentCreator('/wiki/geral/personalizacao/skins/', '64a'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/personalizacao/skins/tlauncher/',
                component: ComponentCreator('/wiki/geral/personalizacao/skins/tlauncher/', 'edf'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/personalizacao/skins/tutorial/',
                component: ComponentCreator('/wiki/geral/personalizacao/skins/tutorial/', '0c9'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/suporte/',
                component: ComponentCreator('/wiki/geral/suporte/', 'cb0'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/suporte/bugs/',
                component: ComponentCreator('/wiki/geral/suporte/bugs/', '7a8'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/suporte/denuncias-apelacoes/',
                component: ComponentCreator('/wiki/geral/suporte/denuncias-apelacoes/', 'f7b'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/geral/suporte/ticket/',
                component: ComponentCreator('/wiki/geral/suporte/ticket/', '98c'),
                exact: true,
                sidebar: "geral"
              },
              {
                path: '/wiki/semi-anarquia/',
                component: ComponentCreator('/wiki/semi-anarquia/', 'd26'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/', '06c'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/ametista/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/ametista/', '81e'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/carmesim/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/carmesim/', '490'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/comum/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/comum/', '606'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/dourada/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/dourada/', '37c'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/prime/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/prime/', '478'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/caixas/votos/',
                component: ComponentCreator('/wiki/semi-anarquia/caixas/votos/', '022'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/chat/',
                component: ComponentCreator('/wiki/semi-anarquia/chat/', '659'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/chat/nickname/',
                component: ComponentCreator('/wiki/semi-anarquia/chat/nickname/', 'd10'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/chat/simbolos/',
                component: ComponentCreator('/wiki/semi-anarquia/chat/simbolos/', 'cf8'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/duelo/',
                component: ComponentCreator('/wiki/semi-anarquia/duelo/', 'e05'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/economia/eteres/',
                component: ComponentCreator('/wiki/semi-anarquia/economia/eteres/', '4fb'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/economia/leilao/',
                component: ComponentCreator('/wiki/semi-anarquia/economia/leilao/', '09d'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/economia/money/',
                component: ComponentCreator('/wiki/semi-anarquia/economia/money/', '169'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/economia/pedidos/',
                component: ComponentCreator('/wiki/semi-anarquia/economia/pedidos/', '409'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/eden/',
                component: ComponentCreator('/wiki/semi-anarquia/eden/', 'cd7'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/mundos/',
                component: ComponentCreator('/wiki/semi-anarquia/mundos/', '1fb'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/teleporte/',
                component: ComponentCreator('/wiki/semi-anarquia/teleporte/', 'ede'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/teleporte/afk/',
                component: ComponentCreator('/wiki/semi-anarquia/teleporte/afk/', 'a51'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/teleporte/home/',
                component: ComponentCreator('/wiki/semi-anarquia/teleporte/home/', 'dd3'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/teleporte/rtp/',
                component: ComponentCreator('/wiki/semi-anarquia/teleporte/rtp/', '238'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/teleporte/tpa/',
                component: ComponentCreator('/wiki/semi-anarquia/teleporte/tpa/', '95d'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/time/',
                component: ComponentCreator('/wiki/semi-anarquia/time/', '3c8'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/', '5a8'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/arcano/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/arcano/', '879'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/celeste/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/celeste/', '0da'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/divino/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/divino/', '128'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/peregrino/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/peregrino/', '9de'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/vip/serafim/',
                component: ComponentCreator('/wiki/semi-anarquia/vip/serafim/', 'e1c'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/votar/',
                component: ComponentCreator('/wiki/semi-anarquia/votar/', '38b'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/semi-anarquia/votar/pinata/',
                component: ComponentCreator('/wiki/semi-anarquia/votar/pinata/', 'f47'),
                exact: true,
                sidebar: "semianarquia"
              },
              {
                path: '/wiki/skyblock/',
                component: ComponentCreator('/wiki/skyblock/', '414'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/',
                component: ComponentCreator('/wiki/skyblock/dungeons/', '49c'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/biblioteca/',
                component: ComponentCreator('/wiki/skyblock/dungeons/biblioteca/', '4cc'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/camara/',
                component: ComponentCreator('/wiki/skyblock/dungeons/camara/', '322'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/fortaleza/',
                component: ComponentCreator('/wiki/skyblock/dungeons/fortaleza/', '7a5'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/mansao/',
                component: ComponentCreator('/wiki/skyblock/dungeons/mansao/', '8ad'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/miragem/',
                component: ComponentCreator('/wiki/skyblock/dungeons/miragem/', 'dd7'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/piratas/',
                component: ComponentCreator('/wiki/skyblock/dungeons/piratas/', 'fbd'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/profundezas/',
                component: ComponentCreator('/wiki/skyblock/dungeons/profundezas/', '13a'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/dungeons/templo/',
                component: ComponentCreator('/wiki/skyblock/dungeons/templo/', 'e1b'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/',
                component: ComponentCreator('/wiki/skyblock/fabricas/', '4a7'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/carvao/',
                component: ComponentCreator('/wiki/skyblock/fabricas/carvao/', '5e9'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/cobre/',
                component: ComponentCreator('/wiki/skyblock/fabricas/cobre/', 'c5f'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/diamante/',
                component: ComponentCreator('/wiki/skyblock/fabricas/diamante/', 'd2a'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/estrela/',
                component: ComponentCreator('/wiki/skyblock/fabricas/estrela/', '372'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/ferro/',
                component: ComponentCreator('/wiki/skyblock/fabricas/ferro/', '57f'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/flecha/',
                component: ComponentCreator('/wiki/skyblock/fabricas/flecha/', 'b02'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/fogos/',
                component: ComponentCreator('/wiki/skyblock/fabricas/fogos/', 'f67'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/gasolina/',
                component: ComponentCreator('/wiki/skyblock/fabricas/gasolina/', '319'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/hidrogenio/',
                component: ComponentCreator('/wiki/skyblock/fabricas/hidrogenio/', 'b54'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/livro/',
                component: ComponentCreator('/wiki/skyblock/fabricas/livro/', '3ec'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/madeira/',
                component: ComponentCreator('/wiki/skyblock/fabricas/madeira/', '55c'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/natherita/',
                component: ComponentCreator('/wiki/skyblock/fabricas/natherita/', 'd97'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/oleo/',
                component: ComponentCreator('/wiki/skyblock/fabricas/oleo/', '045'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/ouro/',
                component: ComponentCreator('/wiki/skyblock/fabricas/ouro/', '544'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/quartzo/',
                component: ComponentCreator('/wiki/skyblock/fabricas/quartzo/', 'd6d'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/tijolos/',
                component: ComponentCreator('/wiki/skyblock/fabricas/tijolos/', '211'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/trigo/',
                component: ComponentCreator('/wiki/skyblock/fabricas/trigo/', 'a6b'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/fabricas/uranio/',
                component: ComponentCreator('/wiki/skyblock/fabricas/uranio/', '4d6'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/ilha/',
                component: ComponentCreator('/wiki/skyblock/ilha/', 'd2f'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/ilha/gerenciamento/',
                component: ComponentCreator('/wiki/skyblock/ilha/gerenciamento/', '181'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/ilha/missoes/',
                component: ComponentCreator('/wiki/skyblock/ilha/missoes/', '136'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/ilha/protecoes/',
                component: ComponentCreator('/wiki/skyblock/ilha/protecoes/', 'd65'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/ilha/warps/',
                component: ComponentCreator('/wiki/skyblock/ilha/warps/', '639'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/kits/',
                component: ComponentCreator('/wiki/skyblock/kits/', 'a7a'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/missoes/',
                component: ComponentCreator('/wiki/skyblock/missoes/', '6c6'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/mundos/',
                component: ComponentCreator('/wiki/skyblock/mundos/', '50d'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/',
                component: ComponentCreator('/wiki/skyblock/skills/', '3e4'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/agilidade/',
                component: ComponentCreator('/wiki/skyblock/skills/agilidade/', 'efd'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/agricultor/',
                component: ComponentCreator('/wiki/skyblock/skills/agricultor/', '8c2'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/alquimia/',
                component: ComponentCreator('/wiki/skyblock/skills/alquimia/', '6c9'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/arquearia/',
                component: ComponentCreator('/wiki/skyblock/skills/arquearia/', '4f0'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/combate/',
                component: ComponentCreator('/wiki/skyblock/skills/combate/', '19f'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/defesa/',
                component: ComponentCreator('/wiki/skyblock/skills/defesa/', '6da'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/encantamento/',
                component: ComponentCreator('/wiki/skyblock/skills/encantamento/', 'f93'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/escavacao/',
                component: ComponentCreator('/wiki/skyblock/skills/escavacao/', 'a68'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/feiticaria/',
                component: ComponentCreator('/wiki/skyblock/skills/feiticaria/', '1af'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/forja/',
                component: ComponentCreator('/wiki/skyblock/skills/forja/', 'b69'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/lenhador/',
                component: ComponentCreator('/wiki/skyblock/skills/lenhador/', 'dcc'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/mana/',
                component: ComponentCreator('/wiki/skyblock/skills/mana/', '447'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/mineracao/',
                component: ComponentCreator('/wiki/skyblock/skills/mineracao/', '56d'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/pescador/',
                component: ComponentCreator('/wiki/skyblock/skills/pescador/', 'fc0'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/skyblock/skills/resistencia/',
                component: ComponentCreator('/wiki/skyblock/skills/resistencia/', '82e'),
                exact: true,
                sidebar: "skyblock"
              },
              {
                path: '/wiki/survival/',
                component: ComponentCreator('/wiki/survival/', 'a21'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/apocalipse/',
                component: ComponentCreator('/wiki/survival/apocalipse/', 'c13'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/apoiador/',
                component: ComponentCreator('/wiki/survival/apoiador/', '16d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/baus/',
                component: ComponentCreator('/wiki/survival/baus/', '986'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/baus/comprar/',
                component: ComponentCreator('/wiki/survival/baus/comprar/', '5fe'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/baus/utilizar/',
                component: ComponentCreator('/wiki/survival/baus/utilizar/', 'c63'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/',
                component: ComponentCreator('/wiki/survival/caixas/', 'edc'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2021/',
                component: ComponentCreator('/wiki/survival/caixas/2021/', '3e6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2021/halloween/',
                component: ComponentCreator('/wiki/survival/caixas/2021/halloween/', 'cca'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2021/natal/',
                component: ComponentCreator('/wiki/survival/caixas/2021/natal/', 'c0b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2022/',
                component: ComponentCreator('/wiki/survival/caixas/2022/', 'a89'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2022/halloween/',
                component: ComponentCreator('/wiki/survival/caixas/2022/halloween/', '77e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2022/junino/',
                component: ComponentCreator('/wiki/survival/caixas/2022/junino/', 'cde'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2022/namorados/',
                component: ComponentCreator('/wiki/survival/caixas/2022/namorados/', '5b6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2022/natal/',
                component: ComponentCreator('/wiki/survival/caixas/2022/natal/', 'e65'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/',
                component: ComponentCreator('/wiki/survival/caixas/2023/', '14a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/aniversario/',
                component: ComponentCreator('/wiki/survival/caixas/2023/aniversario/', '1eb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/criancas/',
                component: ComponentCreator('/wiki/survival/caixas/2023/criancas/', '63b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/halloween/',
                component: ComponentCreator('/wiki/survival/caixas/2023/halloween/', '985'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/inverno/',
                component: ComponentCreator('/wiki/survival/caixas/2023/inverno/', '756'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/namorados/',
                component: ComponentCreator('/wiki/survival/caixas/2023/namorados/', '84c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2023/natal/',
                component: ComponentCreator('/wiki/survival/caixas/2023/natal/', '4c9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/',
                component: ComponentCreator('/wiki/survival/caixas/2024/', '88c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/carnaval/',
                component: ComponentCreator('/wiki/survival/caixas/2024/carnaval/', '79c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/halloween/',
                component: ComponentCreator('/wiki/survival/caixas/2024/halloween/', 'df1'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/natal/',
                component: ComponentCreator('/wiki/survival/caixas/2024/natal/', 'd45'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/pascoa/',
                component: ComponentCreator('/wiki/survival/caixas/2024/pascoa/', 'afa'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/piratas/',
                component: ComponentCreator('/wiki/survival/caixas/2024/piratas/', 'c7e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2024/samurai/',
                component: ComponentCreator('/wiki/survival/caixas/2024/samurai/', 'd89'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2025/',
                component: ComponentCreator('/wiki/survival/caixas/2025/', 'de2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2025/dragao/',
                component: ComponentCreator('/wiki/survival/caixas/2025/dragao/', 'c6f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2025/halloween/',
                component: ComponentCreator('/wiki/survival/caixas/2025/halloween/', '234'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2025/natal/',
                component: ComponentCreator('/wiki/survival/caixas/2025/natal/', '314'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2025/tempestade/',
                component: ComponentCreator('/wiki/survival/caixas/2025/tempestade/', '43b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2026/',
                component: ComponentCreator('/wiki/survival/caixas/2026/', '998'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2026/colapso-infernal/',
                component: ComponentCreator('/wiki/survival/caixas/2026/colapso-infernal/', 'a8d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/caixas/2026/legendaria/',
                component: ComponentCreator('/wiki/survival/caixas/2026/legendaria/', '271'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/camp/',
                component: ComponentCreator('/wiki/survival/camp/', '31a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/camp/chaveamento/',
                component: ComponentCreator('/wiki/survival/camp/chaveamento/', '6eb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/camp/pontuacao/',
                component: ComponentCreator('/wiki/survival/camp/pontuacao/', '3b7'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/camp/premios/',
                component: ComponentCreator('/wiki/survival/camp/premios/', '79c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/camp/regras/',
                component: ComponentCreator('/wiki/survival/camp/regras/', '430'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/chat/',
                component: ComponentCreator('/wiki/survival/chat/', '6c5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/chat/anuncios/',
                component: ComponentCreator('/wiki/survival/chat/anuncios/', '76f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/chat/nickname/',
                component: ComponentCreator('/wiki/survival/chat/nickname/', 'e6b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/chat/simbolos/',
                component: ComponentCreator('/wiki/survival/chat/simbolos/', 'cb0'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/clan/',
                component: ComponentCreator('/wiki/survival/clan/', '71d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/clan/cargo/',
                component: ComponentCreator('/wiki/survival/clan/cargo/', '4ba'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/clan/lider/',
                component: ComponentCreator('/wiki/survival/clan/lider/', 'f2c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/clan/membro/',
                component: ComponentCreator('/wiki/survival/clan/membro/', '8e6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/comandos/',
                component: ComponentCreator('/wiki/survival/comandos/', 'b3f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/desafios/',
                component: ComponentCreator('/wiki/survival/desafios/', 'cc2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/duelo/',
                component: ComponentCreator('/wiki/survival/duelo/', 'bc9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/duelo/duelo_clan/',
                component: ComponentCreator('/wiki/survival/duelo/duelo_clan/', '781'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/duelo/duelo_jogadores/',
                component: ComponentCreator('/wiki/survival/duelo/duelo_jogadores/', '104'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/cash/',
                component: ComponentCreator('/wiki/survival/economia/cash/', 'dab'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/comandos/',
                component: ComponentCreator('/wiki/survival/economia/comandos/', '3a6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/extrato/',
                component: ComponentCreator('/wiki/survival/economia/extrato/', 'c63'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/leilao/',
                component: ComponentCreator('/wiki/survival/economia/leilao/', 'a19'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/loteria/',
                component: ComponentCreator('/wiki/survival/economia/loteria/', '5e2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/pedidos/',
                component: ComponentCreator('/wiki/survival/economia/pedidos/', '953'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/ploja/',
                component: ComponentCreator('/wiki/survival/economia/ploja/', 'b8d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/rifas/como-participar/',
                component: ComponentCreator('/wiki/survival/economia/rifas/como-participar/', 'e24'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/rifas/sorteio-e-premios/',
                component: ComponentCreator('/wiki/survival/economia/rifas/sorteio-e-premios/', '5a9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/economia/sloja/',
                component: ComponentCreator('/wiki/survival/economia/sloja/', '741'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/',
                component: ComponentCreator('/wiki/survival/eventos/', '78f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/anual/',
                component: ComponentCreator('/wiki/survival/eventos/anual/', '689'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/anual/aniversario/',
                component: ComponentCreator('/wiki/survival/eventos/anual/aniversario/', '595'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/anual/halloween/',
                component: ComponentCreator('/wiki/survival/eventos/anual/halloween/', '829'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/anual/natal/',
                component: ComponentCreator('/wiki/survival/eventos/anual/natal/', 'f74'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/',
                component: ComponentCreator('/wiki/survival/eventos/diario/', '406'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/arqueiro/',
                component: ComponentCreator('/wiki/survival/eventos/diario/arqueiro/', 'b6d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/besteiro/',
                component: ComponentCreator('/wiki/survival/eventos/diario/besteiro/', '2e2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/block-party/',
                component: ComponentCreator('/wiki/survival/eventos/diario/block-party/', 'bf6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/carregador-de-gemas/',
                component: ComponentCreator('/wiki/survival/eventos/diario/carregador-de-gemas/', '0e9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/duo/',
                component: ComponentCreator('/wiki/survival/eventos/diario/duo/', 'adb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/gladiador/',
                component: ComponentCreator('/wiki/survival/eventos/diario/gladiador/', '1c6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/killer/',
                component: ComponentCreator('/wiki/survival/eventos/diario/killer/', 'f7d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/lanceiro/',
                component: ComponentCreator('/wiki/survival/eventos/diario/lanceiro/', '9b0'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/paintball-em-time/',
                component: ComponentCreator('/wiki/survival/eventos/diario/paintball-em-time/', '8ad'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/parkour/',
                component: ComponentCreator('/wiki/survival/eventos/diario/parkour/', '46f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/quake-craft/',
                component: ComponentCreator('/wiki/survival/eventos/diario/quake-craft/', '181'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/rei-da-colina/',
                component: ComponentCreator('/wiki/survival/eventos/diario/rei-da-colina/', '831'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/sinuca/',
                component: ComponentCreator('/wiki/survival/eventos/diario/sinuca/', '4dc'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/splatoon-em-time/',
                component: ComponentCreator('/wiki/survival/eventos/diario/splatoon-em-time/', 'ec9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/spleef/',
                component: ComponentCreator('/wiki/survival/eventos/diario/spleef/', 'aad'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/splegg/',
                component: ComponentCreator('/wiki/survival/eventos/diario/splegg/', '1e6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/sumo/',
                component: ComponentCreator('/wiki/survival/eventos/diario/sumo/', 'd36'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/tnt-run/',
                component: ComponentCreator('/wiki/survival/eventos/diario/tnt-run/', '34d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/tnt-tag/',
                component: ComponentCreator('/wiki/survival/eventos/diario/tnt-tag/', 'c18'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/top-matador-em-time/',
                component: ComponentCreator('/wiki/survival/eventos/diario/top-matador-em-time/', 'ffe'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/top-matador/',
                component: ComponentCreator('/wiki/survival/eventos/diario/top-matador/', '3f2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/trio/',
                component: ComponentCreator('/wiki/survival/eventos/diario/trio/', '5ba'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/um-na-camara/',
                component: ComponentCreator('/wiki/survival/eventos/diario/um-na-camara/', 'fbc'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/diario/viking/',
                component: ComponentCreator('/wiki/survival/eventos/diario/viking/', '536'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/mensal/',
                component: ComponentCreator('/wiki/survival/eventos/mensal/', '305'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/mensal/construcao/',
                component: ComponentCreator('/wiki/survival/eventos/mensal/construcao/', 'b80'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/', '7f4'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/arqueiro-dupla/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/arqueiro-dupla/', 'bff'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/arqueiro-trio/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/arqueiro-trio/', 'bdb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/arqueiro/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/arqueiro/', '36b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/barbaro/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/barbaro/', 'fca'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/besteiro-dupla/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/besteiro-dupla/', '65c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/besteiro-trio/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/besteiro-trio/', 'd5d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/besteiro/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/besteiro/', '7fd'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/choque-de-clas/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/choque-de-clas/', '044'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/claxcla/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/claxcla/', 'c6c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/duo/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/duo/', '4a2'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/esmagador/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/esmagador/', 'c4f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/gladiador/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/gladiador/', '4ee'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/guerra/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/guerra/', '7d3'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/lanceiro/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/lanceiro/', 'd8e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/matador/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/matador/', 'ec4'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/sumo/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/sumo/', '060'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/eventos/semanal/trio/',
                component: ComponentCreator('/wiki/survival/eventos/semanal/trio/', '9d6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/genesis/',
                component: ComponentCreator('/wiki/survival/genesis/', '77a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/kits/',
                component: ComponentCreator('/wiki/survival/kits/', '229'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/liga/',
                component: ComponentCreator('/wiki/survival/liga/', 'd3a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/liga/menus/',
                component: ComponentCreator('/wiki/survival/liga/menus/', 'b3e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/liga/pontuacao/',
                component: ComponentCreator('/wiki/survival/liga/pontuacao/', '915'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/liga/premios/',
                component: ComponentCreator('/wiki/survival/liga/premios/', 'a59'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/liga/regras/',
                component: ComponentCreator('/wiki/survival/liga/regras/', '48f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/marry/',
                component: ComponentCreator('/wiki/survival/marry/', '060'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/marry/beneficios/',
                component: ComponentCreator('/wiki/survival/marry/beneficios/', 'c6c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/',
                component: ComponentCreator('/wiki/survival/mcmmo/', '275'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/acrobacia/',
                component: ComponentCreator('/wiki/survival/mcmmo/acrobacia/', '784'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/alquimia/',
                component: ComponentCreator('/wiki/survival/mcmmo/alquimia/', '7f5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/arquearia/',
                component: ComponentCreator('/wiki/survival/mcmmo/arquearia/', '6e4'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/besta/',
                component: ComponentCreator('/wiki/survival/mcmmo/besta/', '1ee'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/comandos/',
                component: ComponentCreator('/wiki/survival/mcmmo/comandos/', '3c6'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/desarmado/',
                component: ComponentCreator('/wiki/survival/mcmmo/desarmado/', 'df3'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/domesticacao/',
                component: ComponentCreator('/wiki/survival/mcmmo/domesticacao/', '491'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/escavacao/',
                component: ComponentCreator('/wiki/survival/mcmmo/escavacao/', 'ec3'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/espada/',
                component: ComponentCreator('/wiki/survival/mcmmo/espada/', '71d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/fundicao/',
                component: ComponentCreator('/wiki/survival/mcmmo/fundicao/', '08c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/herbalismo/',
                component: ComponentCreator('/wiki/survival/mcmmo/herbalismo/', '24c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/lenhador/',
                component: ComponentCreator('/wiki/survival/mcmmo/lenhador/', 'e3c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/machado/',
                component: ComponentCreator('/wiki/survival/mcmmo/machado/', 'a5b'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/mineracao/',
                component: ComponentCreator('/wiki/survival/mcmmo/mineracao/', 'ec7'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/pescaria/',
                component: ComponentCreator('/wiki/survival/mcmmo/pescaria/', '342'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/recuperacao/',
                component: ComponentCreator('/wiki/survival/mcmmo/recuperacao/', '3bc'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/reparo/',
                component: ComponentCreator('/wiki/survival/mcmmo/reparo/', 'b4f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mcmmo/tridente/',
                component: ComponentCreator('/wiki/survival/mcmmo/tridente/', '355'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/',
                component: ComponentCreator('/wiki/survival/melhorias/', '2f3'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/aldeao/',
                component: ComponentCreator('/wiki/survival/melhorias/aldeao/', '770'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/assinatura/',
                component: ComponentCreator('/wiki/survival/melhorias/assinatura/', '444'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/auto/',
                component: ComponentCreator('/wiki/survival/melhorias/auto/', '68a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/bancada/',
                component: ComponentCreator('/wiki/survival/melhorias/bancada/', 'e78'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/cadeira/',
                component: ComponentCreator('/wiki/survival/melhorias/cadeira/', '2fc'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/concreto/',
                component: ComponentCreator('/wiki/survival/melhorias/concreto/', 'd10'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/copyright/',
                component: ComponentCreator('/wiki/survival/melhorias/copyright/', '00d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/drops/',
                component: ComponentCreator('/wiki/survival/melhorias/drops/', 'cca'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/elevador/',
                component: ComponentCreator('/wiki/survival/melhorias/elevador/', '1ef'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/enquetes/',
                component: ComponentCreator('/wiki/survival/melhorias/enquetes/', '551'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/funil/',
                component: ComponentCreator('/wiki/survival/melhorias/funil/', '2e4'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/gerador/',
                component: ComponentCreator('/wiki/survival/melhorias/gerador/', '808'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/informacoes-itens/',
                component: ComponentCreator('/wiki/survival/melhorias/informacoes-itens/', 'b83'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/laco/',
                component: ComponentCreator('/wiki/survival/melhorias/laco/', 'd19'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/moldura/',
                component: ComponentCreator('/wiki/survival/melhorias/moldura/', 'c4c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/mortes/',
                component: ComponentCreator('/wiki/survival/melhorias/mortes/', 'cf4'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/sort/',
                component: ComponentCreator('/wiki/survival/melhorias/sort/', '904'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/supercraft/',
                component: ComponentCreator('/wiki/survival/melhorias/supercraft/', '076'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/suporte/',
                component: ComponentCreator('/wiki/survival/melhorias/suporte/', '387'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/melhorias/venda/',
                component: ComponentCreator('/wiki/survival/melhorias/venda/', 'd1f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/mundos/',
                component: ComponentCreator('/wiki/survival/mundos/', '252'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/perfil/',
                component: ComponentCreator('/wiki/survival/perfil/', '725'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/perfil/config/',
                component: ComponentCreator('/wiki/survival/perfil/config/', '517'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/perfil/playtime/',
                component: ComponentCreator('/wiki/survival/perfil/playtime/', 'a49'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/pets/',
                component: ComponentCreator('/wiki/survival/pets/', 'ad8'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/',
                component: ComponentCreator('/wiki/survival/protecao/', '9cf'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/avancada/',
                component: ComponentCreator('/wiki/survival/protecao/avancada/', '493'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/basica/',
                component: ComponentCreator('/wiki/survival/protecao/basica/', '1c5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/gerenciar/',
                component: ComponentCreator('/wiki/survival/protecao/gerenciar/', 'fd0'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/perda/',
                component: ComponentCreator('/wiki/survival/protecao/perda/', 'e78'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/permissao/',
                component: ComponentCreator('/wiki/survival/protecao/permissao/', 'feb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/protecao/venda/',
                component: ComponentCreator('/wiki/survival/protecao/venda/', '2be'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/tags/',
                component: ComponentCreator('/wiki/survival/tags/', '45a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/tags/personalizar/',
                component: ComponentCreator('/wiki/survival/tags/personalizar/', '1ff'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/tags/utilizar/',
                component: ComponentCreator('/wiki/survival/tags/utilizar/', 'ce9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/teleporte/',
                component: ComponentCreator('/wiki/survival/teleporte/', '4db'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/teleporte/comandos/',
                component: ComponentCreator('/wiki/survival/teleporte/comandos/', '471'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/',
                component: ComponentCreator('/wiki/survival/torneios/', 'dfd'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/alquimista/',
                component: ComponentCreator('/wiki/survival/torneios/alquimista/', '702'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/artesao/',
                component: ComponentCreator('/wiki/survival/torneios/artesao/', 'e8d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/assassino/',
                component: ComponentCreator('/wiki/survival/torneios/assassino/', '005'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/britadeira/',
                component: ComponentCreator('/wiki/survival/torneios/britadeira/', 'fdd'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/caixas/',
                component: ComponentCreator('/wiki/survival/torneios/caixas/', '79e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/defensor/',
                component: ComponentCreator('/wiki/survival/torneios/defensor/', '4e9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/desafiador/',
                component: ComponentCreator('/wiki/survival/torneios/desafiador/', 'b96'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/desmatador/',
                component: ComponentCreator('/wiki/survival/torneios/desmatador/', '761'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/dorminhoco/',
                component: ComponentCreator('/wiki/survival/torneios/dorminhoco/', '431'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/escavador/',
                component: ComponentCreator('/wiki/survival/torneios/escavador/', '5ee'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/explorador/',
                component: ComponentCreator('/wiki/survival/torneios/explorador/', '967'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/farmador/',
                component: ComponentCreator('/wiki/survival/torneios/farmador/', '129'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/fominha/',
                component: ComponentCreator('/wiki/survival/torneios/fominha/', '2d5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/gastador/',
                component: ComponentCreator('/wiki/survival/torneios/gastador/', '6ec'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/marry/',
                component: ComponentCreator('/wiki/survival/torneios/marry/', 'c6e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/mercador/',
                component: ComponentCreator('/wiki/survival/torneios/mercador/', '860'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/metalurgico/',
                component: ComponentCreator('/wiki/survival/torneios/metalurgico/', 'd3d'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/minerios/',
                component: ComponentCreator('/wiki/survival/torneios/minerios/', '0a5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/online/',
                component: ComponentCreator('/wiki/survival/torneios/online/', '3b5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/pedreiro/',
                component: ComponentCreator('/wiki/survival/torneios/pedreiro/', 'df0'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/pescador/',
                component: ComponentCreator('/wiki/survival/torneios/pescador/', 'a96'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/racha-cranio/',
                component: ComponentCreator('/wiki/survival/torneios/racha-cranio/', '53e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/rasante/',
                component: ComponentCreator('/wiki/survival/torneios/rasante/', '49a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/reacao/',
                component: ComponentCreator('/wiki/survival/torneios/reacao/', 'bb5'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/slayer/',
                component: ComponentCreator('/wiki/survival/torneios/slayer/', 'b74'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/tanque/',
                component: ComponentCreator('/wiki/survival/torneios/tanque/', '4ea'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/tryhard/',
                component: ComponentCreator('/wiki/survival/torneios/tryhard/', '6d7'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/vencedor/',
                component: ComponentCreator('/wiki/survival/torneios/vencedor/', 'a83'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/torneios/votos/',
                component: ComponentCreator('/wiki/survival/torneios/votos/', '21c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/',
                component: ComponentCreator('/wiki/survival/vip/', '9aa'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/aniversario/',
                component: ComponentCreator('/wiki/survival/vip/aniversario/', '0cb'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/arara/',
                component: ComponentCreator('/wiki/survival/vip/arara/', 'b93'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/ferias/',
                component: ComponentCreator('/wiki/survival/vip/ferias/', 'caa'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/festa/',
                component: ComponentCreator('/wiki/survival/vip/festa/', 'da7'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/master/',
                component: ComponentCreator('/wiki/survival/vip/master/', '10f'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/natal/',
                component: ComponentCreator('/wiki/survival/vip/natal/', '141'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/premium/',
                component: ComponentCreator('/wiki/survival/vip/premium/', 'e16'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/vip/ultimate/',
                component: ComponentCreator('/wiki/survival/vip/ultimate/', '23a'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/votar/',
                component: ComponentCreator('/wiki/survival/votar/', '449'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/votar/party/',
                component: ComponentCreator('/wiki/survival/votar/party/', '76e'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/votar/premios/',
                component: ComponentCreator('/wiki/survival/votar/premios/', 'f4c'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/votar/streak/',
                component: ComponentCreator('/wiki/survival/votar/streak/', '7c9'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/warp/',
                component: ComponentCreator('/wiki/survival/warp/', 'a88'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/warp/comandos/',
                component: ComponentCreator('/wiki/survival/warp/comandos/', 'dc8'),
                exact: true,
                sidebar: "survival"
              },
              {
                path: '/wiki/survival/warp/tutorial/',
                component: ComponentCreator('/wiki/survival/warp/tutorial/', '58f'),
                exact: true,
                sidebar: "survival"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', '2e1'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
